import { render, staticRenderFns } from "./ReviewSitesView.vue?vue&type=template&id=21f1d928&scoped=true&"
import script from "./ReviewSitesView.vue?vue&type=script&lang=js&"
export * from "./ReviewSitesView.vue?vue&type=script&lang=js&"
import style0 from "./ReviewSitesView.vue?vue&type=style&index=0&id=21f1d928&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f1d928",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VCard,VDialog,VIcon,VImg,VRating})
